exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel-pagination .VueCarousel-dot{background-color:#404040!important}.VueCarousel-pagination .VueCarousel-dot:focus{outline:none!important}.VueCarousel-pagination .VueCarousel-dot--active{background-color:#0df!important}.clipboard-a,.poundSign-a{fill:#28ddfe}.stopwatch{fill:#27dafe}.thumbs{fill:#28ddfe}.tools{fill:#27dafe}.user-a{fill:#28ddfe}", ""]);

// exports
